import { render } from "./FooterNew.vue?vue&type=template&id=2677067f&scoped=true"
const script = {}

import "./FooterNew.vue?vue&type=style&index=0&id=2677067f&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2677067f"]])

export default __exports__